// extracted by mini-css-extract-plugin
export var body = "UpdatePaymentModalV2_body__x7EDI";
export var container = "UpdatePaymentModalV2_container__ruCUj";
export var header = "UpdatePaymentModalV2_header__F5fYH";
export var subtitle = "UpdatePaymentModalV2_subtitle__ERcxA";